import { baseQuery } from "src/store/helpers/baseQuery";
import { keepUnusedDataFor } from "src/store/helpers/cacheLifetime";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient, { type WorkspacesApiForSettingUpdate } from "./rtkClient";

const workspacesApiForSetting: { current: WorkspacesApiForSettingUpdate | null } = { current: null };

export const workspacesApi = createApi({
    reducerPath: "workspacesApi",
    tagTypes: ["Workspaces", "WorkspaceFeatures"],
    keepUnusedDataFor,
    baseQuery,
    endpoints: (builder) => ({
        getAllWorkspaces: rtkClient.getAllWorkspaces(builder),
        getWorkspaces: rtkClient.getWorkspaces(builder),
        getWorkspaceFeatures: rtkClient.getWorkspaceFeatures(builder),
        updateWorkspace: rtkClient.updateWorkspace(builder),
        updateWorkspaceMembers: rtkClient.updateWorkspaceMembers(builder),
        cancelSubscription: rtkClient.cancelSubscription(builder),
        claimStarterSubscription: rtkClient.claimStarterSubscription(builder),
        redeemVoucher: rtkClient.redeemVoucher(builder),
        updateWorkspaceSetting: rtkClient.updateWorkspaceSetting(builder, () => workspacesApiForSetting.current!),
    }),
});
workspacesApiForSetting.current = workspacesApi as WorkspacesApiForSettingUpdate;

export const {
    useCancelSubscriptionMutation,
    useClaimStarterSubscriptionMutation,
    useGetAllWorkspacesQuery,
    useGetWorkspacesQuery,
    useLazyGetWorkspacesQuery,
    useGetWorkspaceFeaturesQuery,
    useUpdateWorkspaceMutation,
    useUpdateWorkspaceMembersMutation,
    useUpdateWorkspaceSettingMutation,
} = workspacesApi;
